import { FC, useCallback } from "react";
import { useSelector } from "react-redux";
import { EmptyMessage } from "src/components";
import { PdTableCellText } from "src/components/layout/table";
import { useFocusableQuery } from "src/hooks/api";
import { tColumn } from "src/hooks/table";
import api from "src/util/apiNew";
import { tBrandInvitationReport } from "tmt_api/src/types/dtos";

import { PdSpinner, ReportTable } from "./components";
import { formatDate, getParams } from "./utils";

const getBrandInvitationsReport = (start: Date, end: Date) =>
  api.get<tBrandInvitationReport[]>("reports/brand-invites", getParams(start, end)).then((res) => res.data);

const columns: tColumn<tBrandInvitationReport>[] = [
  {
    id: "startDateInSeconds",
    header: "Invite Date",
    accessor: (originalRow) => formatDate(originalRow.startDateInSeconds),
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 120 },
  },
  {
    id: "brandName",
    header: "Brand Name",
    accessor: (originalRow) => originalRow.brandName,
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 200 },
  },
  {
    id: "invitedEmail",
    header: "E-mail Address",
    accessor: (originalRow) => originalRow.invitedEmail,
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 240 },
  },
  {
    id: "invitedNote",
    header: "E-mail note",
    accessor: (originalRow) => originalRow.invitedNote || "-",
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 300 },
  },
  {
    id: "status",
    header: "Status",
    accessor: (originalRow) => originalRow.status,
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 120 },
  },
];

const BrandInvitationsTable: FC<{ period: Date[] }> = ({ period }) => {
  const config = useSelector((state) => state.TableConfigReducer.brandInvitingRetailerExcelFormat);
  const { isLoading, data } = useFocusableQuery<tBrandInvitationReport[]>(
    useCallback(() => getBrandInvitationsReport(period[0], period[1]), [period]),
    { enabled: !!(period[0] && period[1]) },
  );

  if (isLoading) {
    return <PdSpinner />;
  }

  if (!data || data?.length === 0) {
    return <EmptyMessage message="There is no data to display" />;
  }

  return (
    <ReportTable
      data={data}
      columns={columns}
      keyExtractor={(item) => item.id}
      sortedBy="startDateInSeconds"
      columnsConfig={config}
      tableConfigReduxKey="brandInvitingRetailerExcelFormat"
    />
  );
};

export default BrandInvitationsTable;
